module.exports = __webpack_public_path__ + "img/linkedin_logo.68ac41e.png";